<template>
    <div v-if="social_login.show" class="flexCenter gridGap margin-top-mid">
        <a v-if="social_login.google" href="/login/auth/google" class="iconGoogle iconGoogle--auth"><img src="/common/images/icons/google.png" alt="Google"></a>
        <a v-if="social_login.facebook" href="/login/auth/facebook" class="iconFacebook iconFacebook--auth"><i class="fab fa-facebook-f"></i></a>
        <a v-if="social_login.linkedin" href="/login/auth/linkedin" class="iconLinkedin iconLinkedin--auth"><i class="fab fa-linkedin-in"></i></a>
    </div>
</template>

<script>

export default {
    name: "SocialLogin",
    props: {
        social_login: {
            default: {},
        }
    }
}
</script>